"use strict";

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @generated SignedSource<<fbcde55f9298a0021c7bdc03f1b22bbc>>
 *
 * 
 * Generated by JSModulesToClientScript
 */
var IntlVariations = {
  BITMASK_NUMBER: 28,
  BITMASK_GENDER: 3,
  NUMBER_ZERO: 16,
  NUMBER_ONE: 4,
  NUMBER_TWO: 8,
  NUMBER_FEW: 20,
  NUMBER_MANY: 12,
  NUMBER_OTHER: 24,
  GENDER_MALE: 1,
  GENDER_FEMALE: 2,
  GENDER_UNKNOWN: 3
};
module.exports = IntlVariations;